"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Fulfill the minimum and maximum values to be at the right place...
 */
function harmonizeBBox(bbox) {
    return {
        maxLat: bbox.maxLat >= bbox.minLat ? bbox.maxLat : bbox.minLat,
        maxLng: bbox.maxLng >= bbox.minLng ? bbox.maxLng : bbox.minLng,
        minLat: bbox.minLat <= bbox.maxLat ? bbox.minLat : bbox.maxLat,
        minLng: bbox.minLng <= bbox.maxLng ? bbox.minLng : bbox.maxLng,
    };
}
exports.harmonizeBBox = harmonizeBBox;
//# sourceMappingURL=bbox.js.map